import { render } from "./ScoreView.vue?vue&type=template&id=ed1a2856&scoped=true&ts=true"
import script from "./ScoreView.vue?vue&type=script&lang=ts"
export * from "./ScoreView.vue?vue&type=script&lang=ts"

import "./ScoreView.scss?vue&type=style&index=0&id=ed1a2856&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1a2856"]])

export default __exports__